import { Component, OnInit } from "@angular/core";
import { Incidencias } from "src/app/shared/model/incidencias/incidencia.model";
import swal from "sweetalert2";

import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  DatePipe,
  NgFor,
  NgIf,
  AsyncPipe,
} from "@angular/common";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { MatButtonModule } from "@angular/material/button";
import {
  MatFormField,
  MatLabel,
  MatInput,
  MatSuffix,
} from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSelect, MatSelectTrigger } from "@angular/material/select";
import { MatOption } from "@angular/material/autocomplete";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from "@angular/material/datepicker";
import { SoloNumeroEnteroDirective } from "../../utilerias/directives/solo-numero-entero.directive";
import { CardIncQAComponent } from "../card-incidencia/card-incQA.component";
import { IconosColumnas, ListaIncidenciasBase } from "../listas-comun/lista-incidencias-base";

/** Tablero de incidencias de QA; la lógica común con el de desarrollo vive en ListaIncidenciasBase. */
@Component({
  selector: "app-incidenciaqa",
  standalone: true,
  templateUrl: "./incidenciaqa.component.html",
  styleUrls: ["./incidenciaqa.component.css"],
  providers: [DatePipe],
  imports: [
    MatFormField,
    MatSelect,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatOption,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    NgFor,
    MatLabel,
    NgIf,
    MatSelectTrigger,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    SoloNumeroEnteroDirective,
    CardIncQAComponent,
    AsyncPipe,
  ],
})
export class IncidenciaQA extends ListaIncidenciasBase implements OnInit {
  override selectProyecto = Number.NaN;
  override selectEtapa = Number.NaN;
  override activaproyecto = false;
  public IncSelProy: string = "incSelProy";
  public IncSelEtapa: string = "incSelEtapa";

  protected readonly iconosColumnas: IconosColumnas = {
    abierto: "error_outline",
    observaciones: "rate_review",
    proceso: "sync",
    resuelto: "task_alt",
    revision: "fact_check",
    vobo: "verified",
    cancelado: "cancel",
  };
  protected readonly puestoEmpleados = "Tester";
  protected readonly campoUsuario = "id_usuario_qa";

  override ngOnInit() {
    this.comunicacion.calbackk.subscribe(() => {
      this.consultaincidencias();
    });
    super.ngOnInit();
  }

  /** Verifica que tipo de usuario es (Líder / Tester) */
  protected asignaUsuarioPorPuesto(emp: Empleado): void {
    if (emp.puesto.puesto === "Tester") {
      this.idUsuario = emp.usuario.id;
    }
  }

  /** Modal's ALTA y VER DETALLES */

  altaincidencia() {
    const pro = this.listaproyectos.find(
      (select) => select.id === this.selectProyecto
    );
    this.router.navigate(["/INCIDENCIAS/INC_QA/alta"], {
      state: { proyecto: pro, idEtapa: this.selectEtapa },
    });
  }

  reporte() {
    const pro = this.listaproyectos.find(
      (select) => select.id === this.selectProyecto
    );
    this.router.navigate(["/INCIDENCIAS/INC_QA/reporte"], {
      state: { proyecto: pro, idEtapa: this.selectEtapa },
    });
  }

  detallesIncidencia(row: Incidencias) {
    const pro = this.listaproyectos.find(
      (select) => select.id === this.selectProyecto
    );
    this.router.navigate(["/INCIDENCIAS/INC_QA/detalle", row.id], {
      state: { incidencia: row, proyecto: pro },
    });
  }

  prepararFiltrosDisponibles() {
    this.prioridad = true;
    this.nombre = true;
    this.estatus = true;
    this.fecha = true;
    this.numero = true;
    this.emp = true;
    this.tipo = true;

    if (!this.listaprioridades) {
      this.cargaPrioridades();
    }

    if (!this.listaTipo) {
      this.cargaTipos();
    }

    // Sale del proyecto sin consultar nada: se recalcula por si cambió la etapa.
    if (this.selectEtapa) {
      this.cargaEmpleados();
    }
  }

  limpiaFiltrosPopup() {
    this.verFiltros = new FormControl();
    this.listaFiltros = [];
    this.prioridades = new FormControl();
    this.verestatus = new FormControl();
    this.tipos = new FormControl();
    this.titulo = "";
    this.numeroInci = null;
    this.idUsuario = null;
    this.fec_ini = null;
    this.fec_fin = null;
    this.search = false;
    this.applyFiltersIncidencias();
  }

  limpiaFiltros() {
    if (this.fecha == false) {
      this.fec_ini = "";
      this.fec_fin = "";
      this.fec_ini = null;
      this.fec_fin = null;
    }

    if (this.prioridad === false) {
      this.prioridades = new FormControl();
    }
    if (this.nombre === false) {
      this.titulo = "";
    }
    if (this.estatus === false) {
      this.verestatus = new FormControl();
    }
    if (this.numero === false) {
      this.numeroInci = null;
    }
    if (this.emp === false) {
      this.idUsuario = null;
    }

    if (this.tipo === false) {
      this.tipos = new FormControl();
    }
    this.applyFiltersIncidencias();
  }

  protected avisaFechaInicial(): void {
    swal.fire({
      title: " Ingresa una Fecha Inicial ",
      timer: 5000,
      icon: "warning",
      customClass: {
        confirmButton: "btn btn-danger",
      },
      showConfirmButton: true,
    });
  }
}
